import { FormulaLexem } from "./FormulaLexem";

/* eslint no-continue: "off" */
/* eslint no-plusplus: "off" */

export const rxUid = /^[\da-f]{8}(-[\da-f]{4}){3}-[\da-f]{12}$/;
// Так исторически сложилось 🤣, что бэковая реализация формул использует префикс a перед uid атрибута
export const rxAUid = /^a[\da-f]{8}(-[\da-f]{4}){3}-[\da-f]{12}$/;

const uidLength = 36;
const availableSymbols = "+-*/^()";

/**
 * @throws Функция генерирует исключения
 */
export const parseLexems = (src: string): FormulaLexem[] => {
  let pos = 0;
  const lexems: FormulaLexem[] = [];
  const subStr = (length: number) => src.slice(pos, pos + length);
  while (pos < src.length) {
    const c = src[pos]!;
    if (/^[\da-f]$/.test(c)) {
      // UID с префиксом
      const textWithPrefix = subStr(uidLength + 1);
      if (rxAUid.test(textWithPrefix)) {
        lexems.push({ type: "uid", text: textWithPrefix.slice(1), pos });
        pos += textWithPrefix.length;
        continue;
      }

      // UID без префикса (сейчас не используется, но пока пусть остаётся)
      const text = subStr(uidLength);
      if (rxUid.test(text)) {
        lexems.push({ type: "uid", text, pos });
        pos += text.length;
        continue;
      }
    }
    if (/^\d$/.test(c)) {
      const text = scanNumber(src, pos);
      lexems.push({ type: "number", text, pos });
      pos += text.length;
      continue;
    }
    pos++;
    if (availableSymbols.includes(c)) {
      lexems.push({ type: "symbol", text: c, pos: pos - 1 });
      continue;
    }
    if (/^\s$/.test(c)) continue;
    throw Error(`Недопустимый символ "${c}" в позиции ${pos}`);
  }
  return lexems;
};

const scanNumber = (src: string, pos: number): string => {
  let end = pos;
  while (end <= src.length) {
    end++;
    if (!/^\d+(\.\d*)?$/.test(src.slice(pos, end))) {
      end--;
      break;
    }
  }
  return src.slice(pos, end);
};
